module.exports = "/static/assets/572a212c2e777e3a9061c97453497009.png";